import React from 'react'
import { Button } from '@mui/material'
import { useStores } from '../../../../app/providers/withStore'
import TourIcon from '@mui/icons-material/Tour'

const StartTourButton = ({ tourKey = 'main', children = 'Пройти тур' }) => {
  const { tourStore } = useStores()

  const handleClick = () => {
    tourStore.loadAndStartTour(tourKey)
  }

  return (
    <Button onClick={handleClick} startIcon={<TourIcon />}>
      {children}
    </Button>
  )
}

export default StartTourButton
